import React, { createContext, useCallback, useContext, useState } from "react";

export const GeneralContext = createContext({
  theme: {},
  ajaxOptions: {},
  ajaxForms: {},
  changeAjaxForms: () => { },
  changeAjaxOptions: () => { },
});

export const GeneralProvider = ({ children, theme }) => {
  const [ajaxOptions, setAjaxOptions] = useState({});
  const [ajaxForms, setAjaxForms] = useState({});

  const changeAjaxOptions = useCallback((key, value) => {
    setAjaxOptions((prev) => ({ ...prev, [key]: value }));
  }, []);

  const changeAjaxForms = useCallback((key, value) => {
    setAjaxForms((prev) => ({ ...prev, [key]: value }));
  }, []);

  return (
    <GeneralContext.Provider value={{ theme, ajaxOptions, changeAjaxOptions, changeAjaxForms, ajaxForms }}>
      {children}
    </GeneralContext.Provider>
  )

};

export const useGeneralContext = () => {
  const value = useContext(GeneralContext);
  return value;
}
